import { render, staticRenderFns } from "./MainPageFilter.vue?vue&type=template&id=52739024"
import script from "./MainPageFilter.vue?vue&type=script&lang=js"
export * from "./MainPageFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports